import { HYDRATE } from 'next-redux-wrapper';

import { IBanner } from '~/src/api/content/banners';
import { IShopItem } from '~/src/api/content/shop/getShopItems';
import { THydrateAction } from '~/src/store';

export enum ESubscriptionsDomruTvActions {
    FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS',
    FETCH_BANNERS = 'FETCH_BANNERS',
}

export interface IBannersResponse {
    isSuccess: boolean,
    payload: IBanner[],
}

export interface ISubscriptionsDomruTvState {
    items: IShopItem[],
    banners: IBannersResponse,
}

const initialState: ISubscriptionsDomruTvState = {
    items: [],
    banners: {
        isSuccess: false,
        payload: [],
    },
};

type TActions = {
    type: ESubscriptionsDomruTvActions,
    payload: ISubscriptionsDomruTvState,
}

const tvSubscriptions = (state = initialState, action: TActions | THydrateAction): ISubscriptionsDomruTvState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case ESubscriptionsDomruTvActions.FETCH_SUBSCRIPTIONS:
            return { ...state, ...action.payload };
        case ESubscriptionsDomruTvActions.FETCH_BANNERS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default tvSubscriptions;
